import { Navigate } from 'react-router-dom';

const PublicRoute = ({ isLoggedIn, children }) => {
  return !isLoggedIn ? children : <Navigate to="/admin/dashboard" replace />;
};

export default PublicRoute